var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { instanceToPlain, plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { Prescription } from 'models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import ApiService from './ApiService';
var PrescriptionService = /** @class */ (function (_super) {
    __extends(PrescriptionService, _super);
    function PrescriptionService() {
        var _this = _super.call(this) || this;
        _this.prescriptionsRoot = 'prescriptions';
        _this.successCreationMessage = '';
        return _this;
    }
    PrescriptionService.prototype.useCreatePrescription = function () {
        var _this = this;
        var queryClient = useQueryClient();
        var patientId;
        return useMutation(function (_a) {
            var prescription = _a.prescription, successMessage = _a.successMessage;
            patientId = prescription.getPatientId();
            _this.successCreationMessage = successMessage;
            var data = { prescription: instanceToPlain(prescription) };
            return _this.post(_this.prescriptionsRoot, { data: data });
        }, {
            onSuccess: function () {
                queryClient.invalidateQueries([queries.patients, patientId, queries.prescriptions]);
                _this.dipatachCreationSuccess({ successMessage: _this.successCreationMessage });
            }
        });
    };
    PrescriptionService.prototype.usePatientPrescriptions = function (patientId) {
        var _this = this;
        return useQuery([queries.patients, patientId, queries.prescriptions], function () {
            return _this.get(_this.prescriptionsRoot, {
                patient_id: patientId
            });
        }, {
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(Prescription, data);
            }
        });
    };
    PrescriptionService.getInstance = function () {
        if (!PrescriptionService.prescriptionService) {
            PrescriptionService.prescriptionService = new PrescriptionService();
        }
        return PrescriptionService.prescriptionService;
    };
    return PrescriptionService;
}(ApiService));
export default PrescriptionService;
